import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  IDumbFilter,
  IEventDumbFilterEdit,
  IEventDumbFilterRemove,
} from '../dumb-filters.types';

@Component({
  selector: 'lum-dumb-filter',
  templateUrl: './dumb-filter.component.html',
  styleUrls: ['./dumb-filter.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class DumbFilterComponent<F extends IDumbFilter = IDumbFilter> {
  @Input() filter :F;
  @Input() index :number;

  @Output() edit = new EventEmitter<IEventDumbFilterEdit>();
  @Output() remove = new EventEmitter<IEventDumbFilterRemove>();

  handleClickAttribute(e :PointerEvent) {
    e.preventDefault();

    this.#edit('attribute');
  }
  handleClickPredicate(e :PointerEvent) {
    e.preventDefault();

    this.#edit('predicate');
  }
  handleClickValue(e :PointerEvent) {
    e.preventDefault();

    this.#edit('value');
  }

  handleClickRemove(e :PointerEvent) {
    e.preventDefault();

    this.#remove();
  }

  #edit(focus ?:IEventDumbFilterEdit['focus']) {
    this.edit.emit({ focus, index: this.index });
  }

  #remove() {
    this.remove.emit({ index: this.index });
  }
}
